import { render, staticRenderFns } from "./ws1-person-warning.vue?vue&type=template&id=fcbcf9e2"
import script from "./ws1-person-warning.vue?vue&type=script&lang=js"
export * from "./ws1-person-warning.vue?vue&type=script&lang=js"
import style0 from "./ws1-person-warning.vue?vue&type=style&index=0&id=fcbcf9e2&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports